import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({

    state: {
        loading: false,
    },

    mutations: {
        changeLoading: state => { state.loading = state.loading ? false : true }
    },

    actions: {
        changeLoading: context => context.commit('changeLoading')
    }

});